const FORCED_AUTHENTICATION = process.env.REACT_APP_FORCED_AUTHENTICATION === "true"
const OSU_NAV_ID = 'osu-navbar'
const MAIN_ID = 'page-content'
const ACCESSIBLE_REFLOW_HEIGHT = `399px`
const TOC_WIDTH = `15rem`
const NAVBAR_WRAPPER_ID = "app-header"
const STATUSES = {
    IDLE: "idle",
    LOADING: "loading",
    ERROR: "error",
    SUCCESS: "success",
    CLEARED: "cleared",
    UNAUTH: "unauth",
    WARNING: "warning",
    COGNITO_FAILURE: "COGNITO_FAILURE",
}
const APPLICATION_NAME = (process.env.APPLICATION_NAME) || 'User Access Management'
const ROLES = {
    ADMIN: 'ADMIN',
    STUDENT: 'STUDENT',
    PARENT: 'PARENT',
    FACULTY: 'FACULTY',
    STAFF: 'STAFF',
    EMPLOYEE: 'EMPLOYEE'
}
const DARK_MODE_CLASSNAME = 'dark-mode-enabled'

const API_ENDPOINT_NAMES = {
    createUser: "createUser"
}

export {
    FORCED_AUTHENTICATION,
    OSU_NAV_ID,
    MAIN_ID,
    ACCESSIBLE_REFLOW_HEIGHT,
    TOC_WIDTH,
    NAVBAR_WRAPPER_ID,
    STATUSES,
    APPLICATION_NAME,
    ROLES,
    DARK_MODE_CLASSNAME,
    API_ENDPOINT_NAMES,
}